import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import moment from "moment";
import { logger } from '../../utils';

export default function EventsDialog({ handleDialogCallback }) {
    const [open, setOpen] = React.useState(false);
    
	const [typeChoices, setTypeChoices] = React.useState([
		{ label: '', value: 0 },
		{ label: 'Weekly', value: 1 },
		{ label: 'Bi-Weekly-Odd', value: 2 },
		{ label: 'Bi-Weekly-Even', value: 3 },
		{ label: 'Monthly', value: 4}
	])
	
	const [weekdays, setWeekdays] = React.useState([
		{ label: 'Monday', value: 0 },
		{ label: 'Tuesday', value: 1 },
		{ label: 'Wednesday', value: 2 },
		{ label: 'Thursday', value: 3 },
		{ label: 'Friday', value: 4 },
		{ label: 'Saturday', value: 5 },
		{ label: 'Sunday', value: 6 }
	]);
	

    const initialValues = {
        EventName: '',
        EventDescription: '',
        EndDate: '',
        IsActive: false,
        Recurring: 0,
        RecurringStart: '',
        RecurringPeriod: 0,
        Urgent: false
    };

    const validFormSchema = Yup.object({        
     	EventName: Yup.string('Enter event name').required('Event name is required'),
        EventDescription: Yup.string('Enter event description').required('Event description is required'),
        EndDate:Yup.date('Enter an end date "MM/DD/YYYY"').required('End date is required "MM/DD/YYYY"'),
        IsActive: Yup.boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            EventName: values.EventName,
            EventDescription: values.EventDescription,
            EndDate: values.EndDate,
            IsActive: values.IsActive,
            Recurring: values.Recurring,
            RecurringStart: values.RecurringStart,
        	RecurringPeriod: values.RecurringPeriod,
        	Urgent: values.Urgent
        };

        logger("onTrigger", msg);
        handleDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {

    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Event
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Add Event
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Event Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="EventName"
                                            variant="outlined"
                                            id="outlined-eventName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.EventName}
                                            error={props.touched.EventName && Boolean(props.errors.EventName)}
                                            helperText={props.touched.EventName && props.errors.EventName}                                          
                                            label="Event Name"
                                        />
                                    </FormControl>
                                     <FormControl sx={{ m: 1, width: 240 }}>
										<TextField
											name='EndDate'
											id="outlined-EndDate"
											type="date"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.EndDate}
											error={props.touched.EndDate && Boolean(props.errors.EndDate)}
											helperText={props.touched.EndDate && props.errors.EndDate}
											label="End Date"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</FormControl>
                                </div>
                                <div>
                                	<FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-propEntryType">Recurring</InputLabel>
                                        <CustomSelect
                                            name="Recurring"
                                            id="outlined-Recurring"
                                            options={typeChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Recurring}
                                            label="Recurring"
                                        />
                                    </FormControl>
                                	<FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="EventDescription"
                                            variant="outlined"
                                            id="outlined-EventDescription"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.EventDescription}
                                            error={props.touched.EventDescription && Boolean(props.errors.EventDescription)}
                                            helperText={props.touched.EventDescription && props.errors.EventDescription}                                          
                                            label="Event Description"
                                            multiline
                                            rows={4}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                	{(props.values.Recurring===1 || props.values.Recurring===2 || props.values.Recurring===3) && 
                                	<FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-propEntryType">Recurring Start</InputLabel>
                                        <CustomSelect
                                            name="RecurringStart"
                                            id="outlined-RecurringStart"
                                            options={weekdays}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.RecurringStart}
                                            label="Recurring Start"
                                            error={props.touched.RecurringStart && Boolean(props.errors.RecurringStart)}
                                            helperText={props.touched.RecurringStart && props.errors.RecurringStart} 
                                        />
                                    </FormControl>
									}
									{props.values.Recurring===4 && 
									<FormControl sx={{ m: 1, width: 240 }}>
										<TextField
											name='RecurringStart'
											id="outlined-RecurringStart"
											type="date"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.RecurringStart}
											error={props.touched.RecurringStart && Boolean(props.errors.RecurringStart)}
											helperText={props.touched.RecurringStart && props.errors.RecurringStart}
											label="Recurring Start"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</FormControl>
									}
									 {(props.values.Recurring!==0) 
									 	&& <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="RecurringPeriod"
                                            variant="outlined"
                                            type="number"
                                            id="outlined-RecurringPeriod"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.RecurringPeriod}
                                            error={props.touched.RecurringPeriod && Boolean(props.errors.RecurringPeriod)}
                                            helperText={props.touched.RecurringPeriod && props.errors.RecurringPeriod}                                          
                                            label="Recurring Period"
                                        />
                                    </FormControl>
                                    }
                                </div>
                                <FormControlLabel
                                    name="IsActive"
                                    label="Active"
                                    control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                      />
                                <FormControlLabel
                                    name="Urgent"
                                    label="Urgent"
                                    control={<Checkbox checked={props.values.Urgent} onChange={props.handleChange} />}
                                />
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog>
        </div>
    );
}